import { useContext } from 'react';
import {
  useModel as _useModel,
  Store,
  useLocalModel as _useLocalModel,
} from '@reduck/core';
import { Context } from './context';

let useInGarfish = false;

export function markGarfish() {
  useInGarfish = true;
}

function transferToUseMasterHook(modelHook: any): any {
  return (namespaces: string | Array<string | Function>, deps: any[]) => {
    const contextValue = useContext(Context);

    if (!contextValue) {
      console.error(
        `[@jupiter-app/plugin-state]: please ensure App is wrapped in GarfishContextProvider`,
      );
      return;
    }

    const store = contextValue.store;

    return modelHook(
      namespaces2ReduckModel(
        Array.isArray(namespaces) ? namespaces : [namespaces],
        store,
      ),
      deps,
      {},
      { context: Context },
    );
  };
}

function namespaces2ReduckModel(
  namespaces: Array<string | Function>,
  store: Store,
) {
  return namespaces
    .map((ns: string | Function) => {
      if (typeof ns === 'string') {
        return (
          store?._context?._models?.[ns] ||
          console.warn(
            `[@jupiter-app/plugin-state]: ${ns} is not loaded by master App's store, please check`,
          )
        );
      }

      return false;
    })
    .filter(Boolean);
}

function likeSameModel(modelA: any, modelB: any) {
  if (!modelA || !modelB) {
    return false;
  }

  if (
    Object.keys(modelA.state || {}).toString() ===
      Object.keys(modelB.state || {}).toString() &&
    Object.keys(modelA.actions || {}).toString() ===
      Object.keys(modelB.actions || {}).toString()
  ) {
    return true;
  }

  return false;
}

function wrapUseModel(useModelFn: Function) {
  return (...args: any[]) => {
    if (!useInGarfish) {
      return useModelFn(...args);
    }

    const contextValue = useContext(Context);

    if (!contextValue) {
      return useModelFn(...args);
    }

    let models = [];

    if (Array.isArray(args[0])) {
      models = args[0];
    } else {
      models = [args[0]];
    }

    models = models.filter(model => {
      if (typeof model === 'function') {
        return false;
      }

      return true;
    });

    if (
      models.every((model: any) => {
        return likeSameModel(
          contextValue.store?._context?._models?.[
            model.name || model.namespace
          ],
          model,
        );
      })
    ) {
      // 第四个参数传入context
      args[3] = { context: Context };
    }

    return useModelFn(...args);
  };
}

export const useMasterModel = transferToUseMasterHook(_useModel);
export const useMatserLocalModel = transferToUseMasterHook(_useLocalModel);
export const useModel = wrapUseModel(_useModel) as typeof _useModel;
export const useLocalModel = wrapUseModel(
  _useLocalModel,
) as typeof _useLocalModel;
